import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('CREATE_NATIONALITY'),
  ...asyncTypes('UPDATE_NATIONALITY')
};

export default TYPES;
